import { render, staticRenderFns } from "./callUp.vue?vue&type=template&id=dcf9229a&scoped=true&"
import script from "./callUp.vue?vue&type=script&lang=js&"
export * from "./callUp.vue?vue&type=script&lang=js&"
import style0 from "./callUp.vue?vue&type=style&index=0&id=dcf9229a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcf9229a",
  null
  
)

export default component.exports